module.exports = __webpack_public_path__ + "assets/42c793508b29159cdec1350ad06e3a6c.png";